import { DateTime, Settings } from 'luxon';

/* Setting the default timezone to Riyadh. */
Settings.defaultZone = 'Asia/Riyadh';

export { DateTime, Settings };
